import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { BooleanValueAccessor, InputText, TextValueAccessor } from '@shui/angular';
import { FileUploadItem, ShFileInputComponent } from '../../sh-file-input/sh-file-input.component';

export type {
    ExternalReferralDialogData,
    ExternalReferralDialogResult,
    ExternalReferralFormGroup
} from '../model/external-referral-dialog.model';
import type {
    ExternalReferralDialogData,
    ExternalReferralDialogResult,
    ExternalReferralFormGroup
} from '../model/external-referral-dialog.model';

@Component({
    selector: 'sh-external-referral-dialog',
    templateUrl: './external-referral-dialog.component.html',
    imports: [
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ShFileInputComponent,
        BooleanValueAccessor,
        TextValueAccessor,
        InputText
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExternalReferralDialog {
    private readonly dialogRef = inject<MatDialogRef<ExternalReferralDialog>>(MatDialogRef);
    public data = inject<ExternalReferralDialogData>(MAT_DIALOG_DATA);

    protected formGroup = new FormGroup<ExternalReferralFormGroup>({
        name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
        referredOutEmail: new FormControl<string>('', {
            nonNullable: true,
            validators: [Validators.required, Validators.email]
        }),
        description: new FormControl<string | null>(null, {
            validators: this.data.isReferredOutAfterSubmission ? [] : [Validators.required, Validators.pattern(/\S/)]
        }),
        attachments: new FormControl<FileUploadItem[] | null>(null),
        markAsInternal: new FormControl<boolean>(false, { nonNullable: true })
    });

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
            return;
        }
        const v = this.formGroup.controls;
        this.dialogRef.close({
            name: v.name.value,
            email: v.referredOutEmail.value,
            description: v.description.value,
            attachments: v.attachments.value,
            markAsInternal: v.markAsInternal.value
        } satisfies ExternalReferralDialogResult);
    }
}
